const name = 'vendaCPR'
const templateUrl = new URL('./template.html', import.meta.url).href
const controller = () => import('./controller.js')

export default {
    name,
    controller,
    templateUrl
}
